/** Shared with factz_react/src/lib/preferV3.ts — keep keys in sync. */
export const PREFER_V3_KEY = "factz.preferV3"
export const PREFER_V3_DECLINED_UNTIL_KEY = "factz.preferV3.declinedUntil"
export const PREFER_V3_CLASSIC_TIP_KEY = "factz.preferV3.showClassicTip"

const THREE_DAYS_MS = 3 * 24 * 60 * 60 * 1000

export function prefersV3() {
  try {
    return localStorage.getItem(PREFER_V3_KEY) === "1"
  } catch {
    return false
  }
}

export function setPreferV3() {
  localStorage.setItem(PREFER_V3_KEY, "1")
  localStorage.setItem(PREFER_V3_CLASSIC_TIP_KEY, "1")
  localStorage.removeItem(PREFER_V3_DECLINED_UNTIL_KEY)
}

export function clearPreferV3() {
  localStorage.removeItem(PREFER_V3_KEY)
}

export function declinePreferV3ForThreeDays() {
  const until = new Date(Date.now() + THREE_DAYS_MS).toISOString()
  localStorage.setItem(PREFER_V3_DECLINED_UNTIL_KEY, until)
}

export function isPreferV3Declined() {
  try {
    const raw = localStorage.getItem(PREFER_V3_DECLINED_UNTIL_KEY)
    if (!raw) return false
    const until = Date.parse(raw)
    if (Number.isNaN(until)) return false
    if (until > Date.now()) return true
    localStorage.removeItem(PREFER_V3_DECLINED_UNTIL_KEY)
    return false
  } catch {
    return false
  }
}

export function shouldPromptPreferV3() {
  return !prefersV3() && !isPreferV3Declined()
}

export function redirectToV3() {
  window.location.replace("/v3/")
}
